import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPatreonComponent } from './simple-icons-patreon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPatreonComponent ],
    exports:      [ SimpleIconsPatreonComponent ],
    bootstrap:    []
})
export class SimpleIconsPatreonModule {}
